import React, { useRef } from 'react';
import classnames from 'classnames';

import { useScenarioEditor } from './ScenarioEditorContext';
import MedContraindications from './MedContraindications';
// import { processForm } from './formUtils';

const Medications = ({ active }) => {
    const {scenario, saveScenario, scenarioType} = useScenarioEditor();
    const formEL = useRef(null);
    const isAdult = scenario.info.patientInformation.age >= 14;

    const clickHandler = async (event) => {
        event.preventDefault()
        await saveScenario(scenario)
    }


    return (
        <div className='scenario-form-wrapper'>
            <form
                className={classnames("scenario-form", { "scenario-view-hidden": false })}
                ref={formEL}
            >
                <button className="save-changes" type="submit" onClick={clickHandler}>Save Changes</button>

                <div className="info-wrapper" id="medications">
                    <h1>Medication Dosages</h1>

                    <div className="meds-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Medication</th>
                                    <th>Administrative Route</th>
                                    <th>Initial Dosage</th>
                                    <th>Contraindications</th>
                                    {/* <th>Max Dosage</th>
                                    <th>Repeat Dosage</th>
                                    <th>Repeat Frequency</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {scenarioType._medications.map(med => (
                                    <Med key={med.id}
                                        med={med}
                                        isAdult={isAdult}
                                        scenario={scenario}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <button className="save-changes" type="submit" onClick={clickHandler}>Save Changes</button>

            </form>
        </div>
    )
}

export default Medications;

const Med = ({ scenario, med, isAdult }) => {
    let self = scenario.correctMedicationDosages[med.id];
    const type = isAdult ? "adult" : "pediatric";

    if (!self.route) self.route = "";
    if (!self.contraindications) self.contraindications = [];

    const handleSelect = e => {
        console.log(e.target.value)
        self.route = e.target.value;
    }

    const handleInput = e => {
        self[e.target.name] = e.target.value;
    }

    const handleCheck = e => {
        const kind = e.target.name;
        const val = e.target.value;
        e.target.checked
            ? self[kind].push(val)
            : self[kind].splice(self[kind].indexOf(val), 1);
    }

    return (
        <tr key={`${med.id}-row`}>
            <th>{med.label}</th>
            <td>
                <div className="route-dropdown">
                    <select id={`correctMedicationDosages-${med.id}-route`}
                        defaultValue={self.route}
                        onChange={handleSelect} >
                        <option hidden>-- Select Route --</option>
                        {med[type].routes.map(route => (
                            <option key={route} value={route}>
                                {route}
                            </option>
                        ))}
                    </select>
                </div>
            </td>
            <td>
                <p className="value-hint">{med[type].initialDosage || "None Set"}</p>
                <input type="text"
                    id={`correctMedicationDosages-${med.id}-initialDosage`}
                    defaultValue={self["initialDosage"]}
                    name="initialDosage"
                    onChange={handleInput}
                />
            </td>
            <td align="center">
                <MedContraindications med={med} parent={self} update={handleCheck} />
            </td>
            {/* <td>
                <p className="value-hint">{med[type].maxDosage || "None Set"}</p>
                <input type="text"
                    id={`correctMedicationDosages-${med.id}-maxDosage`}
                    defaultValue={self["maxDosage"]}
                    name="maxDosage"
                    onChange={handleInput}
                />
            </td>
            <td>
                <p className="value-hint">{med[type].repeatDosage || "None Set"}</p>
                <input type="text"
                    id={`correctMedicationDosages-${med.id}-repeatDosage`}
                    defaultValue={self["repeatDosage"]}
                    name="repeatDosage"
                    onChange={handleInput}
                />
            </td>
            <td>
                <p className="value-hint">{med[type].repeatInterval || "None Set"}</p>
                <input type="text"
                    id={`correctMedicationDosages-${med.id}-repeatFrequency`}
                    defaultValue={self["repeatFrequency"]}
                    name="repeatFrequency"
                    onChange={handleInput}
                />
            </td> */}
        </tr>
    );
}